// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router/index.js";
// import 'bootstrap/dist/css/bootstrap.min.css'
import "./common/local.bootstrap.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/font-awesome/css/font-awesome.min.css";
import httpRequest from "./common/axiosHttp";
import "babel-polyfill";
import Promise from "promise";
import waterfall from "vue-waterfall2";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

import iView from "iview";
import "iview/dist/styles/iview.css";
import touch from "touch";

import i18n from "@/locale";

// 可拖拽组件 拖拽组件的样式在使用的页面单独导入 避免全局导入带来样式异常的问题
import VueDraggableResizable from "vue-draggable-resizable";
// 导入如下
import "vue-draggable-resizable/dist/VueDraggableResizable.css";

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(Viewer);
Viewer.setDefaults({
  zIndexInline: 99999
});
Vue.prototype.i18nTitle = function(val) {
  let reg = new RegExp("[\\u4E00-\\u9FFF|]+", "g"); //|符号订单管理有字段拼接
  return reg.test(val) ? i18n.t(val) : val;
};
iView.Message.config({
  top: 50,
  duration: 3
});

iView.Notice.config({
  top: 70,
  duration: 3
});
Vue.use(iView);
// 重写toFixed方法解决精度问题
Number.prototype.toFixed = function(d) {
  let s = this + "";
  if (!d) d = 0;
  if (s.indexOf(".") == -1) s += ".";
  s += new Array(d + 1).join("0");
  if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
    let s = "0" + RegExp.$2,
      pm = RegExp.$1,
      a = RegExp.$3.length,
      b = true;
    if (a == d + 2) {
      a = s.match(/\d/g);
      if (parseInt(a[a.length - 1]) > 4) {
        for (let i = a.length - 2; i >= 0; i--) {
          a[i] = parseInt(a[i]) + 1;
          if (a[i] == 10) {
            a[i] = 0;
            b = i != 1;
          } else break;
        }
      }
      s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");
    }
    if (b) s = s.substr(1);
    return (pm + s).replace(/\.$/, "");
  }
  return this + "";
};

import {
  Carousel,
  CarouselItem,
  Cascader,
  Transfer,
  Select,
  Option,
  DatePicker,
  Tree,
  Button,
  Input,
  Drawer,
  Popover,
  Row,
  Col,
  Dialog,
  RadioButton,
  Checkbox,
  CheckboxGroup,
  CheckboxButton,
  Switch,
  Radio,
  RadioGroup,
  Table,
  TableColumn,
  Pagination,
  Tooltip,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Link,
  Progress,
  Card,
  Steps,
  Step,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Divider,
  InputNumber
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.component("el-carousel", Carousel);
Vue.component("el-carousel-item", CarouselItem);
Vue.component("el-cascader", Cascader);
Vue.component("el-transfer", Transfer);
Vue.component("el-select", Select);
Vue.component("el-option", Option);
Vue.component("el-date-picker", DatePicker);
Vue.component("el-tree", Tree);
Vue.component("el-button", Button);
Vue.component("el-input", Input);
Vue.component("el-drawer", Drawer);
Vue.component("el-popover", Popover);
Vue.component("el-row", Row);
Vue.component("el-col", Col);
Vue.component("el-dialog", Dialog);
Vue.component("el-checkbox", Checkbox);
Vue.component("el-checkbox-group", CheckboxGroup);
Vue.component("el-checkbox-button", CheckboxButton);
Vue.component("el-switch", Switch);
Vue.component("el-radio", Radio);
Vue.component("el-radio-button", RadioButton);
Vue.component("el-radio-group", RadioGroup);
Vue.component("el-table", Table);
Vue.component("el-table-column", TableColumn);
Vue.component("el-pagination", Pagination);
Vue.component("el-tooltip", Tooltip);
Vue.component("el-form", Form);
Vue.component("el-form-item", FormItem);
Vue.component("el-tabs", Tabs);
Vue.component("el-tab-pane", TabPane);
Vue.component("el-tag", Tag);
Vue.component("el-link", Link);
Vue.component("el-progress", Progress);
Vue.component("el-dropdown", Dropdown);
Vue.component("el-dropdown-menu", DropdownMenu);
Vue.component("el-dropdown-item", DropdownItem);
Vue.component("el-steps", Steps);
Vue.component("el-step", Step);
Vue.component("el-card", Card);
Vue.component("el-input-number", InputNumber);
Vue.component("el-divider", Divider);

import apiCenter from "./common/apiCenter.json";
// Vue.prototype.publishSubscribe = publishSubscribe;
import { validate } from "./common/validate.js";
import publicMethod from "./common/js/publicMethod.js"; //使用
// import extractFunc from "./common/js/extractFunc.js";
import httpRequestEntrance from "./common/httpRequestEntrance.js";
// import { tableUtil } from "./common/tableUtil.js";
import { commonFunc } from "@/common/commonFunction";

import jquery from "jquery";
Vue.prototype.apiCenter = apiCenter;
Vue.prototype.$validate = validate;
Vue.prototype.$httpRequestEntrance = httpRequestEntrance;
// Vue.prototype.$tableUtil = tableUtil;
Vue.prototype.$commonFunc = commonFunc;
Vue.prototype.JQ = jquery;
Vue.prototype.Promise = Promise;
Vue.prototype.$publicMethod = publicMethod;
// Vue.prototype.$extractFunc = extractFunc;
Vue.prototype.$touch = touch;

// select插件
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

// 删除模态框插件
// import deleteComponent from "./components/common-temp/delete-component/delete-component.js";
// Vue.use(deleteComponent);
// 确认操作模态框插件
// import confirmComponent from "./components/common-temp/confirm-component/confirm-component.js";
// Vue.use(confirmComponent);

// import VeeValidate from "./common/veeValidate/VeeValidate";
// Vue.use(VeeValidate);

// import smsDeleteUse from "./components/common-temp/smsDelete";
// Vue.use(smsDeleteUse);

// import switchBtnUse from "./components/common-temp/switchBtn";
// Vue.use(switchBtnUse);

// import simpleTable from "./components/common-temp/simpleTable";
// Vue.use(simpleTable);

import Vuex from "vuex";
Vue.use(Vuex);
import store from "./store/index.js";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
Vue.use(waterfall);

// Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));
// Object.keys(directives).forEach(k => Vue.directive(k, directives[k]));

Vue.config.productionTip = false;
Vue.prototype.httpRequest = httpRequest;

let appKey_product = "955748b048ef42b78c08bcefbf0470ba"; //招商云门户_生产
let appKey_test = "fc78a0911902488a80daddaba62cdd16"; //招商云门户_测试
let key = null;
if (
  window.location.host.includes("sit") ||
  window.location.host.includes("dev") ||
  window.location.host.includes("uat") ||
  window.location.host.includes("localhost")
) {
  key = appKey_test;
} else {
  key = appKey_product;
}
// 初始化
// appKey为系统（touch.cmft.com）分配的appKey,必传
touch.init({
  base_url: "https://touch.cmft.com",
  debugMode: true,
  appKey: key,
  trackAllbyAttrbute: false,
  requestIdMode: 1,
  autoCollectPage: false, //关闭自动上报
  offline: false //页面地址使用url
});

Vue.component("vue-draggable-resizable", VueDraggableResizable);

Vue.component("tdSlot", {
  render(createElement) {
    function deepClone(vnodes, createElement) {
      function cloneVNode(vnode) {
        const clonedChildren =
          vnode.children && vnode.children.map(vnode => cloneVNode(vnode));
        const cloned = createElement(vnode.tag, vnode.data, clonedChildren);
        cloned.text = vnode.text;
        cloned.isComment = vnode.isComment;
        cloned.componentOptions = vnode.componentOptions;
        cloned.elm = vnode.elm;
        cloned.context = vnode.context;
        cloned.ns = vnode.ns;
        cloned.isStatic = vnode.isStatic;
        cloned.key = vnode.key;

        return cloned;
      }
      const clonedVNodes = vnodes.map(vnode => cloneVNode(vnode));
      return clonedVNodes;
    }
    //this.$parent.$parent.$slots.default针对detail-table中往modal中注入slot,因为modal本身是一个组件，被detail-table，故多一层$parent
    //var slots = this.$parent.$slots.default.length === 1 && !this.$parent.$slots.default[0].data.slot ? this.$parent.$parent.$slots.default:this.$parent.$slots.default
    var slot = null;
    function search(val) {
      //普通page组件涉及一层组件传递 detail-component涉及两层slot传递 new-detail涉及三层slot传递，所以使用递归查找slot
      if (
        val.$parent.$slots.default.length === 1 &&
        !val.$parent.$slots.default[0].data.slot
      ) {
        return search(val.$parent);
      } else {
        return val.$parent.$slots.default;
      }
    }
    var slots = search(this);
    for (let i = 0; i < slots.length; i++) {
      if (slots[i].data && this.name === slots[i].data.slot) {
        slot = slots[i];
        break;
      }
    }
    return createElement("div", deepClone([slot], createElement));
  },
  props: {
    name: {
      type: String,
      default: ""
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js